import gridLayoutReducer from "./gridLayoutReducer";
import notificationReducer from "./notificationReducer";
import userDetailsReducer from "./userReducer";
import formsReducer from "./formsReducer";
import clientSideFilterReducer from "./clientSideFilterReducer";

import * as gridActions from "./gridLayoutReducer";
import * as clientSideFilterActions from "./clientSideFilterReducer";

const reducers = {
  gridLayout: gridLayoutReducer,
  userDetails: userDetailsReducer,
  forms: formsReducer,
  notification: notificationReducer,
  clientSideFilter: clientSideFilterReducer,
};

export const actions = {
  gridActions,
  clientSideFilterActions,
};

export default reducers;
